module.exports = __webpack_public_path__ + "static/media/loading.3d9f27ba.svg";